/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Standard_DescriptionInputs */

const et_plan_standard_description = /** @type {(inputs: Plan_Standard_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google esi 3-me 90 päevaga. Garanteeeritud.`)
};

const en_plan_standard_description = /** @type {(inputs: Plan_Standard_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google top 3 within 90 days. Guaranteed.`)
};

/**
* | output |
* | --- |
* | "Google top 3 within 90 days. Guaranteed." |
*
* @param {Plan_Standard_DescriptionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_standard_description = /** @type {((inputs?: Plan_Standard_DescriptionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Standard_DescriptionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_standard_description(inputs)
	return en_plan_standard_description(inputs)
});